<template>
    <div>

        <nav>
            <div class="nav nav-tabs mb-4" id="nav-tab" role="tablist">
                <button class="nav-link active" id="nav-general-tab" data-bs-toggle="tab" data-bs-target="#nav-general" type="button" role="tab" aria-controls="nav-general" aria-selected="true">{{ __('General') }}</button>
                <!--<button class="nav-link" id="nav-properties-tab" data-bs-toggle="tab" data-bs-target="#nav-properties" type="button" role="tab" aria-controls="nav-properties" aria-selected="false">{{ __('Properties') }}</button>-->
                <button class="nav-link" id="nav-prices-tab" data-bs-toggle="tab" data-bs-target="#nav-prices" type="button" role="tab" aria-controls="nav-prices" aria-selected="false">{{ __('Prices') }}</button>
                <button class="nav-link" id="nav-variants-tab" data-bs-toggle="tab" data-bs-target="#nav-variants" type="button" role="tab" aria-controls="nav-variants" aria-selected="false" v-if="form.parent_id === null">{{ __('Variants') }}</button>
                <!--<button class="nav-link" id="nav-seo-tab" data-bs-toggle="tab" data-bs-target="#nav-seo" type="button" role="tab" aria-controls="nav-seo" aria-selected="false">{{ __('SEO') }}</button>-->
            </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane fade show active" id="nav-general" role="tabpanel" aria-labelledby="nav-general-tab">
                <div class="row row-cols-1 row-cols-lg-2 g-4 mb-4">

                    <div class="col">
                        <div class="card">
                            <div class="card-body">
                                <fieldset>
                                    <legend>{{ __('Product') }}</legend>

                                    <select-input label="supplier_id" v-model="form.supplier_id" v-if="suppliers" :error="form.errors.supplier_id">
                                        <option :value="null">{{ __('Please select') }}</option>
                                        <option :value="supplier.id" v-for="supplier in suppliers">{{ supplier.short_name }}</option>
                                    </select-input>

                                    <checkbox-input label="enabled" v-model="form.enabled" :error="form.errors.enabled" />

                                    <text-input label="name" v-model="form.name" :error="form.errors.name" />
                                    <text-input label="slug" v-model="form.slug" :error="form.errors.slug" />

                                    <div class="row row-cols-1 row-cols-sm-2">
                                        <div class="col">
                                            <text-input label="ean" v-model="form.ean" 
                                                        :error="form.errors.ean"/>
                                        </div>
                                        <div class="col">
                                            <text-input label="sku" v-model="form.sku" :error="form.errors.sku" />
                                        </div>
                                        <div class="col">
                                            <text-input label="supplier_pid" v-model="form.supplier_pid" 
                                                        :error="form.errors.supplier_pid" />
                                        </div>
                                        <div class="col">
                                            <text-input label="supplier_alt_pid" v-model="form.supplier_alt_pid" 
                                                        :error="form.errors.supplier_alt_pid" />
                                        </div>
                                        <div class="col">
                                            <text-input label="manufacturer_pid" v-model="form.manufacturer_pid" 
                                                        :error="form.errors.manufacturer_pid"" />
                                        </div>
                                        <div class="col">
                                            <text-input type="datetime-local" label="available_from" v-model="form.available_from" 
                                                        :error="form.errors.available_from"/>
                                        </div>
                                        <div class="col">
                                            <text-input type="datetime-local" label="available_until" v-model="form.available_until" 
                                                        :error="form.errors.available_until"/>
                                        </div>
                                        <div class="col">
                                            <checkbox-input label="free_delivery" v-model="form.free_delivery" 
                                                            :error="form.errors.free_delivery"
                                                            :help="__('Versandkostenfreie Produkte werden generell mit 0,00 EUR Versandkosten im Checkout berechnet.')" />
                                        </div>
                                    </div>

                                </fieldset>



                                <fieldset>
                                    <text-input type="datetime-local" label="release_date" v-model="form.release_date" :error="form.errors.release_date" />
                                    <checkbox-input label="write_protected" v-model="form.write_protected" :error="form.errors.write_protected" :help="__('Produkt vor Überschreiben durch Import sperren.')" />
                                    <checkbox-input label="mdr_classified" v-model="form.mdr_classified" />
                                    <checkbox-input label="hazardous_material" v-model="form.hazardous_material" />
                                </fieldset>



                            </div>
                        </div>
                    </div>

                    <div class="col">
                        <div class="card">
                            <div class="card-body">
                                <fieldset>
                                    <legend>{{ __('Stock') }}</legend>
                                    <div class="row row-cols-1 row-cols-sm-2">
                                        <div class="col w-100">
                                            <!--@todo manage_stock im ganzen shop berücksichtigen, auch wenn stock_quantity gefüllt ist!-->
                                            <checkbox-input label="manage_stock" v-model="form.manage_stock" 
                                                            :error="form.errors.manage_stock"/>
                                        </div>
                                        <div class="col">
                                            <text-input type="number" 
                                                        label="stock_quantity" 
                                                        v-model="form.stock_quantity" 
                                                        :error="form.errors.stock_quantity"
                                                        :disabled="!form.manage_stock" />
                                        </div>
                                        <div class="col">
                                            <text-input type="date" 
                                                        label="restock_date" 
                                                        v-model="form.restock_date" 
                                                        :error="form.errors.restock_date"
                                                        :disabled="!form.manage_stock" />        
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>

                    <div class="col">
                        <div class="card">
                            <div class="card-body">
                                <fieldset>
                                    <legend>{{ __('Bestellmengen') }}</legend>
                                    <div class="row row-cols-1 row-cols-sm-2">
                                        <div class="col">
                                            <text-input type="number" label="quantity_min" v-model="form.quantity_min" 
                                                        :error="form.errors.quantity_min"/>
                                        </div>
                                        <div class="col">
                                            <text-input type="number" label="quantity_max" v-model="form.quantity_max" 
                                                        :error="form.errors.quantity_max"/>
                                        </div>
                                        <div class="col">
                                            <text-input type="number" label="quantity_interval" v-model="form.quantity_interval" 
                                                        :error="form.errors.qantity_interval"/>
                                        </div>
                                        <div class="col">
                                            <select-input label="order_unit_id" v-model="form.order_unit_id"
                                                          :error="form.errors.order_unit_id"
                                                          :help="__('Einheit, in der das Produkte bestellt werden kann; es können nur Vielfache dieser Einheit bestellt werden. Auf diese Einheit (oder auf Teile oder auf Vielfache davon) bezieht sich stets auch der Preis.')">
                                                <option :value="null">{{ __('Bitte wählen') }}</option>
                                                <option v-for="orderUnit in orderUnits" :value="orderUnit.id">{{ orderUnit.name }}</option>
                                            </select-input>
                                        </div>
                                        <div class="col">
                                            <select-input label="content_unit_id" 
                                                          v-model="form.content_unit_id"
                                                          :help="__('Einheit des Produktes innerhalb einer Bestelleinheit')">
                                                <option :value="null">{{ __('Bitte wählen') }}</option>
                                                <option v-for="contentUnit in orderUnits" :value="contentUnit.id">{{ contentUnit.name }}</option>
                                            </select-input>
                                        </div>
                                        <div class="col">
                                            <text-input type="number"
                                                        label="content_units_per_order_unit"
                                                        min="0" 
                                                        v-model="form.content_units_per_order_unit"
                                                        :help="__('Anzahl der Inhaltseinheiten pro Bestelleinheit des Artikels')" />
                                        </div>
                                        <div class="col">
                                            <text-input type="number" min="1" label="price_quantity" v-model="form.price_quantity" :error="form.errors.price_quantity" />
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>

                    <div class="col">
                        <div class="card">
                            <div class="card-body">
                                <fieldset>
                                    <legend>{{ __('Logistik') }}</legend>
                                    <div class="row row-cols-1 row-cols-sm-2">
                                        <div class="col">
                                            <text-input type="number" label="volume" min="0" step=".0001" v-model="form.volume" 
                                                        :help="__('Volumen in Kubikmeter (m³)')"
                                                        :error="form.errors.volume"/>
                                        </div>
                                        <div class="col">
                                            <text-input type="number" label="weight" min="0" step=".0001" v-model="form.weight" 
                                                        :help="__('Gewicht in Kilogramm (kg)')"
                                                        :error="form.errors.weight"/>
                                        </div>
                                        <div class="col">
                                            <text-input type="number" label="length" min="0" step=".0001" v-model="form.length" 
                                                        :help="__('Länge in Meter (m)')"
                                                        :error="form.errors.length"/>
                                        </div>
                                        <div class="col">
                                            <text-input type="number" label="width" min="0" step=".0001" v-model="form.width" 
                                                        :help="__('Breite in Meter (m)')"
                                                        :error="form.errors.width"/>
                                        </div>
                                        <div class="col">
                                            <text-input type="number" label="depth" min="0" step=".0001" v-model="form.depth" 
                                                        :help="__('Tiefe in Meter (m)')"
                                                        :error="form.errors.depth"/>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>

                    <div class="col">
                        <div class="card">
                            <div class="card-body">
                                <fieldset>
                                    <legend>{{ __('Hinweise') }}</legend>
                                    <textarea-input label="delivery_policy" v-model="form.delivery_policy" :error="form.errors.delivery_policy" />
                                    <textarea-input label="purchase_note" v-model="form.purchase_note" :error="form.errors.purchase_note" />
                                    <textarea-input label="refund_policy" v-model="form.refund_policy" :error="form.errors.refund_policy" />
                                    <textarea-input label="return_policy" v-model="form.return_policy" :error="form.errors.return_policy" />
                                </fieldset>
                            </div>
                        </div>
                    </div>

                    <div class="col">
                        <div class="card">
                            <div class="card-body">
                                <fieldset>
                                    <legend>{{ __('Marketing') }}</legend>
                                    <!-- @todo <textarea-input label="keywords" v-model="form.keywords" :error="form.errors.keywords" />-->
                                    <text-input label="template" v-model="form.template" :error="form.errors.template" />
                                    <text-input type="email" label="contact_email" v-model="form.contact_email" :error="form.errors.contact_email" />
                                    <!--@todo kann das jeder bearbeiten?-->
                                    <!--<text-input type="number" label="sales" v-model="form.sales" :error="form.errors.sales" />-->
                                    <checkbox-input label="top_seller" v-model="form.top_seller" :error="form.errors.top_seller" />
                                    <text-input label="meta_title" v-model="form.meta_title" :error="form.errors.meta_title" />
                                    <textarea-input label="meta_description" v-model="form.meta_description" :error="form.errors.meta_description" />
                                </fieldset>
                            </div>
                        </div>
                    </div>

                    <div class="col w-100">
                        <div class="card">
                            <div class="card-body">
                                <fieldset>
                                    <legend>{{ __('Inhalte') }}</legend>
                                    <div class="mb-3">
                                        <editor-input label="excerpt" v-model="form.excerpt" :error="form.errors.excerpt" />
                                    </div>
                                    <div class="mb-3">
                                        <editor-input label="description" v-model="form.description" rows="20" :error="form.errors.description" />
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="row row-cols-1 row-cols-lg-2 g-4">

                    <div class="col w-100">
                        <div class="card">
                            <div class="card-body">
                                <fieldset>
                                    <legend>{{ __('Categories') }}</legend>

                                    <div class="mb-3 text-muted">
                                        {{ __('Sie können maximal 10 Kategorien auswählen.') }}
                                    </div>

                                    <multi-select-input
                                        v-model="form.categories"
                                        value-consists-of="ALL"
                                        value-format="object"
                                        :flat="true"
                                        sort-value-by="INDEX"
                                        :multiple="true" 
                                        :always-open="false"
                                        :limit="10"
                                        :options="categoryOptions" 
                                        :placeholder="__('Search categories')" 
                                        :error="form.errors.categories"
                                        />

                                </fieldset>
                            </div>
                        </div>
                    </div>


                    <!--@todo ggf trennen in bilder und dokumente-->
                    <!--                    <div class="col w-100">
                                            <div class="card">
                                                <div class="card-body">
                                                    <fieldset>
                                                        <legend>{{ __('Bilder und Dokumente') }}</legend>
                    
                                                        <div class="" v-if="form.main_image_id">
                                                            <img class="img-fluid" :src="product.main_image_url" :alt="product.name" loading="lazy" style="max-width: 300px;" />
                                                        </div>
                    
                                                        <div class="table-responsive">
                                                            <table class="">
                                                                <tr v-for="attachment in form.attachments">
                                                                    <td>
                                                                        <img :src="attachment.thumbnail_url" alt="" style="max-height: 60px;" />
                                                                    </td>
                                                                    <td>
                                                                        <text-input label="title" v-model="attachment.title" />
                                                                    </td>
                                                                    <td>
                                                                        <text-input label="filename" v-model="attachment.filename" />
                                                                    </td>
                                                                    <td>
                                                                        <text-input label="source_url" v-model="attachment.source_url" />
                                                                    </td>
                                                                    <td>
                                                                        <text-input label="mime_type" v-model="attachment.mime_type" />
                                                                    </td>
                                                                    <td>
                                                                        <text-input label="alt_text" v-model="attachment.alt_text" />
                                                                    </td>
                                                                    <td>
                                                                        <text-input label="purpose" v-model="attachment.purpose" />
                                                                    </td>
                                                                    <td class="">
                                                                        <button type="button" class="btn btn-outline-danger">
                                                                            <i class="bi bi-trash"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </div>
                                                    </fieldset>
                                                </div>
                                            </div>
                                        </div>-->

                </div>

            </div>

            <div class="tab-pane fade" id="nav-properties" role="tabpanel" aria-labelledby="nav-properties-tab">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Properties') }}</legend>

                            <!--@todo sortable-->
                            <div class="bg-light p-4 rounded-3 mb-3" v-for="(property, index) in form.properties">
                                <div class="row mb-3">
                                    <div class="col">
                                        <text-input label="property" v-model="property.name" />
                                    </div>
                                    <div class="col">
                                        <textarea-input label="value" v-model="property.pivot.data" />
                                    </div>
                                </div>
                                <div class="d-flex justify-content-end gap-2">
                                    <button type="button" class="btn btn-outline-secondary" @click="cloneProductProperty(index)">
                                        {{ __('Duplizieren') }}
                                    </button>
                                    <button type="button" class="btn btn-outline-danger" @click="removeProductProperty(index)">
                                        {{ __('Löschen') }}
                                    </button>
                                </div>
                            </div>

                            <button type="button" class="btn btn-outline-primary" @click="addProductProperty">
                                <i class="bi bi-plus"></i>
                                {{ __('Add property') }}
                            </button>
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade" id="nav-prices" role="tabpanel" aria-labelledby="nav-prices-tab">
                <fieldset>
                    <!--@todo sortable-->
                    <!--@todo price_type tabs?-->
                    <div class="list-group mb-3">
                        <div class="list-group-item list-group-item-light p-3" v-for="(productPrice, priceIndex) in form.product_prices">
                            <div class="d-flex">
                                <div class="">
                                    <div class="row row-cols-1 row-cols-md-3 row-cols-lg-4 mb-2">
                                        <select-input label="price_type" v-model="productPrice.price_type" 
                                                      :error="form.errors[`product_prices.${priceIndex}.price_type`]">
                                            <option v-for="(v, k) in priceTypeOptions" :value="k">{{ v }}</option>
                                        </select-input>
                                        <text-input type="number" 
                                                    label="lower_bound" 
                                                    min="0" 
                                                    step=".0001"
                                                    v-model="productPrice.lower_bound"
                                                    :error="form.errors[`product_prices.${priceIndex}.lower_bound`]"/>
                                        <price-input
                                            label="price" 
                                            v-model="productPrice.price" 
                                            :error="form.errors[`product_prices.${priceIndex}.price`]" />
                                        <text-input type="number" 
                                                    label="price_factor"
                                                    min="0" 
                                                    step=".0001"
                                                    v-model="productPrice.price_factor"
                                                    :error="form.errors[`product_prices.${priceIndex}.price_factor`]"/>
                                        <percent-input  
                                            label="tax_rate" 
                                            v-model="productPrice.tax_rate" 
                                            :error="form.errors[`product_prices.${priceIndex}.tax_rate`]" />
                                        <text-input
                                            label="tax_exemption_reason"
                                            v-model="productPrice.tax_exemption_reason"
                                            :error="form.errors[`product_prices.${priceIndex}.tax_exemption_reason`]"/>
                                        <select-input label="currency_id"
                                                      v-model="productPrice.currency_id" 
                                                      :error="form.errors[`product_prices.${priceIndex}.currency_id`]">
                                            <option v-for="currency in currencies" :value="currency.id">{{ currency.iso_4217 }}</option>
                                        </select-input>
                                        <div class="w-100"></div>
                                        <text-input type="date" 
                                                    label="valid_from" 
                                                    v-model="productPrice.valid_from"
                                                    :error="form.errors[`product_prices.${priceIndex}.valid_from`]"/>
                                        <text-input type="date"
                                                    label="valid_until"
                                                    v-model="productPrice.valid_until"
                                                    :error="form.errors[`product_prices.${priceIndex}.valid_until`]"/>
                                    </div>
                                </div>
                                <div class="ms-3">
                                    <div class="d-grid gap-2">
                                        <button type="button" class="btn btn-outline-secondary" @click="cloneProductPrice(priceIndex)">
                                            {{ __('Duplizieren') }}
                                        </button>
                                        <button type="button" class="btn btn-outline-danger" v-if="priceIndex > 0" @click="removeProductPrice(priceIndex)">
                                            {{ __('Löschen') }}
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                    <button type="button" class="btn btn-outline-primary" @click="addProductPrice()">
                        <i class="bi bi-plus"></i>
                        {{ __('Add price') }}
                    </button>  
                </fieldset>

            </div>

            <div class="tab-pane fade" id="nav-variants" role="tabpanel" aria-labelledby="nav-variants-tab" v-if="form.parent_id === null">
                <div class="card">
                    <div class="">

                        <data-table :items="form.variants"
                                    :columns="variantColumns"
                                    >
                            <data-table-row v-for="variant in form.variants" :key="variant.id">
                                <!--                <td>
                                                    {{ variant.supplier.short_name || '-' }}
                                                </td>-->
                                <td class="text-center">
                                    <img class="img-fluid" :src="variant.main_image_url" alt="" style="min-width: 70px; max-height: 50px; width: auto;" loading="lazy" />
                                </td>
                                <td class="text-nowrap">
                                    {{ variant.sku }}
                                </td>
                                <td class="text-nowrap">
                                    {{ variant.supplier_pid }}
                                </td>
                                <td class="">
                                    <inertia-link class=" stretched-link" :href="route('admin.products.edit', variant)">
                                        {{ variant.name }}
                                    </inertia-link>
                                </td>
                                <td>
                                    <boolean :value="variant.enabled" />
                                </td>
                                <td>
                                    <template v-if="variant.manage_stock">
                                        <span v-if="variant.stock_quantity > 0" :title="__('Auf Lager')" class="text-success">
                                            <i class="bi bi-circle-fill"></i>
                                        </span>
                                        <span v-else-if="variant.stock_quantity === 0" :title="__('Nicht auf Lager')" class="text-danger">
                                            <i class="bi bi-circle-fill"></i>
                                        </span>
                                        {{ variant.stock_quantity || 0 | localizeNumber }}
                                    </template>
                                    <template v-else>
                                        {{ __('-') }}
                                    </template>
                                </td>
                                <td class="text-nowrap">
                                    <div v-if="variant.default_price">
                                        {{ variant.default_price.price | localizeAmount }}
                                    </div>
                                    <div v-else>
                                        <em>{{ __('Kein Preis') }}</em>
                                    </div>
                                </td>
                                <td class="text-end">
                                    <i class="bi bi-chevron-right"></i>
                                </td>
                            </data-table-row>
                        </data-table>
                    </div>

                </div>

                <!--           @todo     <button type="button" class="btn btn-outline-primary" @click="addVariant()">
                                    <i class="bi bi-plus"></i>
                                    {{ __('Variante hinzufügen') }}
                                </button>-->
            </div>

            <!--            <div class="tab-pane fade" id="nav-seo" role="tabpanel" aria-labelledby="nav-seo-tab">
            
                        </div>-->

        </div>

        <div class="mt-4 d-flex align-items-center gap-3 w-100">
            <submit-button :form="form"  />
            <button type="button" class="btn link-danger" @click="destroy" v-if="product">
                {{ __('Put in trash') }}
            </button>
        </div>

    </div>
</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import FileInput from '@/shared/Inputs/FileInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';
    import PriceInput from '@/shared/Inputs/PriceInput';
    import PercentInput from '@/shared/Inputs/PercentInput';
    import EditorInput from '@/shared/Inputs/EditorInput';
    import MultiSelectInput from '@/shared/Inputs/MultiSelectInput';

    import Boolean from '@/shared/Admin/Boolean';
    import DataTable from '@/shared/Admin/DataTable';
    import DataTableRow from '@/shared/Admin/DataTableRow';

    export default {
        props: [
            'form',
            'product',
            'currencies',
            'orderUnits',
            'priceTypeOptions',
            'categoryTree',
            'suppliers',
        ],
        data() {
            return {
                categoryOptions: this.categoryTree,
                variantColumns: {
                    image: {label: 'Image'},
                    sku: {label: 'SKU', sortable: 'sku'},
                    supplier_pid: {label: 'AID/PID', sortable: 'supplier_pid', info: 'Supplier PID'},
                    name: {label: 'Name', sortable: 'name'},
                    enabled: {label: 'Enabled', sortable: 'enabled'},
                    stock_quantity: {label: 'Stock quantity', sortable: 'stock_quantity'},
                    price: {label: 'Price'},
                },
            }
        },
        components: {
            TextInput,
            FileInput,
            SelectInput,
            TextareaInput,
            CheckboxInput,
            SubmitButton,
            PriceInput,
            PercentInput,
            EditorInput,
            MultiSelectInput,
            Boolean,
            DataTable,
            DataTableRow,
        },
        watch: {
        },
        methods: {
//            addProductDetail() {
//                if (this.form.product_details.length >= 100) {
//                    alert('Sie können maximal 100 Varianten angeben.');
//                    return false;
//                }
//
//                const productDetail = {
//                    product_prices: [{
//                            price_type: 'net_customer',
//                            currency_id: this.currencies[0].id,
//                        }],
//                };
//                this.form.product_details.push(productDetail);
//            },
//            removeProductDetail(index) {
//                Vue.delete(this.form.product_details, index);
//            },
            // @todo variante autom. aus properties generieren
            addProductPrice() {

                if (this.form.product_prices.length >= 100) {
                    alert('Sie können maximal 100 Preise angeben.');
                    return false;
                }

                const price = {
                    price_type: 'net_customer',
                    lower_bound: 1,
                    price_factor: 1,
                    currency_id: this.currencies[0].id,
                };
                this.form.product_prices.push(price);
            },
            cloneProductPrice(index) {

                if (this.form.product_prices.length >= 100) {
                    alert('Sie können maximal 100 Preise angeben.');
                    return false;
                }

                let cloned = JSON.parse(JSON.stringify(this.form.product_prices[index]));
                cloned.id = null;

                this.form.product_prices.push(cloned);
            },
            removeProductPrice(index) {
                if (this.form.product_prices.length === 1) {
                    alert('Es ist mindestens ein Preis erforderlich.');
                    return false;
                }

                Vue.delete(this.form.product_prices, index);
            },
            addProductProperty() {

                if (this.form.properties.length >= 100) {
                    alert('Sie können maximal 100 Eigenschaften angeben.');
                    return false;
                }

                const property = {
                    pivot: {}
                };
                this.form.properties.push(property);
            },
            cloneProductProperty(index) {
                if (this.form.properties.length >= 100) {
                    alert('Sie können maximal 100 Eigenschaften angeben.');
                    return false;
                }

                let cloned = JSON.parse(JSON.stringify(this.form.properties[index]));
                cloned.id = null;

                this.form.properties.push(cloned);
            },
            removeProductProperty(index) {
                Vue.delete(this.form.properties, index);
            },
            destroy() {
                this.$inertia.delete(this.route('admin.products.destroy', this.product));
            },

        },
    }
</script>
